import { ButtonSecondary, ButtonSize, IconDownload } from '@ui/src';
import {
  newApplicationListColumnsLabels as applicationsColumnsLabels,
  newApplicationListFiltersSchema as applicationsFiltersSchema,
} from '@clients/hoc/new-application/list/variables/list';
import {
  columnsLabels as incomingColumnsLabels,
  filtersSchema as incomingFiltersSchema,
} from '@transactions/hoc/incoming/variables/list';
import {
  columnsLabels as outgoingColumnsLabels,
  filtersSchema as outgoingFiltersSchema,
} from '@transactions/hoc/outgoing/variables/list';
import {
  columnsLabels as internalColumnsLabels,
  filtersSchema as internalFiltersSchema,
} from '@transactions/hoc/internal/variables/list';
import {
  columnsLabels as exchangeColumnsLabels,
  filtersSchema as exchangeFiltersSchema,
} from '@transactions/hoc/exchange/variables/list';
import {
  columnsLabels as cashCollectionColumnsLabels,
  filtersSchema as cashCollectionFiltersSchema,
} from '@transactions/hoc/cash-collection/variables/list';
import {
  columnsLabels as glColumnsLabels,
  filtersSchema as glFiltersSchema,
} from '@transactions/hoc/general-ledger/variables/list';
import {
  columnsLabels as nostroColumnsLabels,
  filtersSchema as nostroFiltersSchema,
} from '@transactions/hoc/nostro/variables/list';
import FiltersPreset from './filters-preset';
import { FilterPresetTypes } from './types';

import cn from './profile.module.css';

const FiltersPresets = ({ userId }: FilterPresetTypes) => {
  const onDownloadAllPresets = () => {
    const filtersPresetsKeys = [
      'incoming-filters',
      'outgoing-filters',
      'internal-filters',
      'exchange-filters',
      'cash-collection-filters',
      'general-ledger-filters',
      'nostro-filters',
      'applications-filters',
    ];

    filtersPresetsKeys.forEach((item) => {
      const fileContent: {
        key: string;
        values?: {
          id: string;
          name: string;
          value: Record<string, any>;
          default?: boolean;
          employeeId: string;
        }[];
      } = {
        key: item,
      };

      const filtersPresetsJSON = localStorage.getItem(item);

      if (filtersPresetsJSON) {
        const parsed = JSON.parse(filtersPresetsJSON);

        if (parsed) {
          fileContent.values = parsed?.filter(
            (filterItem: any) => filterItem.employeeId === userId,
          );
        }

        const blob = new Blob([JSON.stringify(fileContent)], {
          type: 'text/plain',
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');

        const savedFiltersName = item
          ?.split('-')
          ?.map((key) => `${key.charAt(0).toUpperCase()}${key.slice(1)}`)
          ?.join(' ');

        a.href = url;
        a.download = `${savedFiltersName} Preset`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }
    });
  };

  return (
    <div className={cn.filtersPresetsContent}>
      <div className={`${cn.employeeProfileTitle} ${cn.flex}`}>
        Filter Presets
        <ButtonSecondary
          size={ButtonSize.SMALL}
          icon={<IconDownload />}
          text="Export all Presets"
          className={`button-white ${cn.downloadAllPresets}`}
          onClick={onDownloadAllPresets}
        />
      </div>
      <FiltersPreset
        title="Incoming Transactions"
        userId={userId}
        filtersPresetKey="incoming-filters"
        columnsLabels={incomingColumnsLabels}
        filtersSchema={incomingFiltersSchema}
      />
      <FiltersPreset
        title="Outgoing Transactions"
        userId={userId}
        filtersPresetKey="outgoing-filters"
        columnsLabels={outgoingColumnsLabels}
        filtersSchema={outgoingFiltersSchema}
      />
      <FiltersPreset
        title="Internal Transactions"
        userId={userId}
        filtersPresetKey="internal-filters"
        columnsLabels={internalColumnsLabels}
        filtersSchema={internalFiltersSchema}
      />
      <FiltersPreset
        title="Exchange Transactions"
        userId={userId}
        filtersPresetKey="exchange-filters"
        columnsLabels={exchangeColumnsLabels}
        filtersSchema={exchangeFiltersSchema}
      />
      <FiltersPreset
        title="Cash Collection Transactions"
        userId={userId}
        filtersPresetKey="cash-collection-filters"
        columnsLabels={cashCollectionColumnsLabels}
        filtersSchema={cashCollectionFiltersSchema}
      />
      <FiltersPreset
        title="General Ledger Transactions"
        userId={userId}
        filtersPresetKey="general-ledger-filters"
        columnsLabels={glColumnsLabels}
        filtersSchema={glFiltersSchema}
      />
      <FiltersPreset
        title="Nostro Transactions"
        userId={userId}
        filtersPresetKey="nostro-filters"
        columnsLabels={nostroColumnsLabels}
        filtersSchema={nostroFiltersSchema}
      />
      <FiltersPreset
        title="Applications"
        userId={userId}
        filtersPresetKey="applications-filters"
        columnsLabels={applicationsColumnsLabels}
        filtersSchema={applicationsFiltersSchema}
      />
    </div>
  );
};

export default FiltersPresets;
